@if (selections) {
  <mat-card appearance="outlined" class="expanding-panel">
    @for (selection of selections; track selection) {
      <mat-content
        class="selection"
        (click)="selection.onSelect()"
        >
        <a href="javascript:void(0)" >
          <span>{{ selection.label }}</span>
        </a>
      </mat-content>
    }
  </mat-card>
}
